exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea{\r\n  display: block;\r\n  box-sizing: padding-box;\r\n  padding: 10px;\r\n  width: 250px;\r\n  font-size: 14px;\r\n  margin-top: 100px;\r\n  border-radius: 6px;\r\n  box-shadow: 2px 2px 8px rgba(black, .3);\r\n  border: 0;\r\n  height: 450px;\r\n}\r\n\r\ntextarea:focus{\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n.text-area{\r\n  margin-right: 0px;\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.modal-content {\r\n  background-color: transparent;\r\n  box-shadow: none;\r\n  border-width: 0px;\r\n}\r\n\r\n.btn-primary {\r\n  float: right\r\n}\r\n\r\n.col-sm-12 {\r\n  padding: 0px;\r\n}\r\n\r\n.task {\r\n  width: 100%\r\n}\r\n\r\n.notification {\r\n  width: 80%;\r\n  margin: 40px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/modal-expanded-textfield/modal-expanded-textfield.component.css
// module id = ../../../../../src/app/controllers/calendars/modal-expanded-textfield/modal-expanded-textfield.component.css
// module chunks = main